import React from 'react';
import { formatDurationMinutes, formatPercent } from './chartUtils';

export interface TatComplianceData {
  averageMinutes: number;
  medianMinutes: number;
  withinSla: number;
  exceedingSla: number;
  compliancePercent: number;
  notConfigured: number;
}

interface TatCompliancePanelProps {
  data: TatComplianceData;
}

export default function TatCompliancePanel({ data }: Readonly<TatCompliancePanelProps>) {
  const items = [
    { label: 'Average TAT', value: formatDurationMinutes(data.averageMinutes) },
    { label: 'Median TAT', value: formatDurationMinutes(data.medianMinutes) },
    { label: 'Within SLA', value: String(data.withinSla) },
    { label: 'Exceeding SLA', value: String(data.exceedingSla) },
    { label: 'Compliance', value: formatPercent(data.compliancePercent) },
    { label: 'TAT not configured', value: String(data.notConfigured) },
  ];

  return (
    <section className="analytics-chart-card analytics-tat-compliance-card">
      <h3 className="analytics-chart-card-title analytics-tat-compliance-title">TAT compliance</h3>
      <div className="analytics-tat-compliance-grid">
        {items.map(item => (
          <div
            key={item.label}
            className="analytics-tat-compliance-item"
          >
            <p className="analytics-tat-compliance-label">{item.label}</p>
            <p className="analytics-tat-compliance-value">{item.value}</p>
          </div>
        ))}
      </div>
    </section>
  );
}
